try {
    function headerControll() {
        if (!document.querySelector("header")) return false;
        let header = document.querySelector("header");
        let trigger_open = header.querySelector("#open_menu");
        let trigger_close = header.querySelector("#close_menu");
        let mob_menu = header.querySelector(".menu");

        trigger_open.addEventListener("click", () => {
            mob_menu.classList.add("open");
            document.body.style.overflow = "hidden";
        });
        trigger_close.addEventListener("click", () => {
            if (document.body.hasAttribute("style")) {
                document.body.removeAttribute("style");
            }
            mob_menu.classList.remove("open");
        });

        function setGoClass() {
            if (window.scrollY > 0 && !header.classList.contains("go")) {
                header.classList.add("go");
            }
            if (window.scrollY <= 0 && header.classList.contains("go")) {
                header.classList.remove("go");
            }
        }

        window.addEventListener("scroll", setGoClass);
    }
    /*
    function brokenScroll() {
        if (!document.querySelector('[data-action="broken-scroll"]')) return;
        let parent = document.querySelector('[data-action="broken-scroll"]');
        let scrollBlock = parent.querySelector('[data-scroll-elem="true"]');
        let header = document.querySelector("header");
        const maxScreen = 993;
        let mob = document.documentElement.offsetWidth <= maxScreen;
        let headerH = header.offsetHeight;

        let scrollY = window.pageYOffset;
        let scrollY_H = scrollY + headerH;

        let elemPos = parent.getBoundingClientRect();
        let elemTop = elemPos.top + scrollY;
        let elemBot = elemPos.bottom + scrollY;

        let elemScrollW = scrollBlock.scrollWidth;
        let elemWidth = scrollBlock.offsetWidth;
        let elemScrollDifferent = elemScrollW - elemWidth;
        let elemHeigh = scrollBlock.offsetHeight;
        let parentHeight = parent.offsetHeight;
        if (!mob) {
            parent.style.height = elemScrollDifferent + parentHeight + "px";
        }

        let stepY = 0;
        let stepX = 0;

        function update() {
            mob = document.documentElement.offsetWidth <= maxScreen;

            parent.removeAttribute("style");
            scrollBlock.removeAttribute("style");
            scrollY = window.pageYOffset;
            scrollY_H = scrollY + headerH;

            elemPos = parent.getBoundingClientRect();
            elemTop = elemPos.top + scrollY;
            elemBot = elemPos.bottom + scrollY;

            elemScrollW = scrollBlock.scrollWidth;
            elemWidth = scrollBlock.offsetWidth;
            elemScrollDifferent = elemScrollW - elemWidth;
            elemHeigh = scrollBlock.offsetHeight;
            parentHeight = parent.offsetHeight;
            if (!mob) {
                parent.style.height = elemScrollDifferent + parentHeight + "px";
            }

            stepY = 0;
            stepX = 0;
            AOS.refresh();
        }

        function move() {
            if (mob) return;
            let down = scrollY < window.pageYOffset ? true : false;
            scrollY = window.pageYOffset;
            scrollY_H = scrollY + headerH;
            console.log("elemScrollDifferent", elemScrollDifferent, "stepX", stepX);
            if (
                elemTop <= scrollY_H &&
                elemScrollDifferent >= scrollY_H - elemTop &&
                down
            ) {
                stepY = scrollY_H - elemTop;
                stepX = stepY;
                //scrollBlock.style.top = stepY + "px";
                //scrollBlock.style.right = stepY + "px";
                $('[data-scroll-elem="true"]').css('transform', 'translate(-' + stepY + 'px,' + stepY + 'px)');
                return;
            }
            let actualTopBlock = scrollBlock.getBoundingClientRect().top + scrollY;
            if (!down &&
                elemTop <= scrollY_H &&
                stepX >= 0 &&
                actualTopBlock > scrollY_H &&
                elemScrollDifferent >= scrollY_H - elemTop
            ) {
                stepY = scrollY_H - elemTop;
                stepX = stepY;
                //scrollBlock.style.top = stepY + "px";
                //scrollBlock.style.right = stepY + "px";
                $('[data-scroll-elem="true"]').css('transform', 'translate(-' + stepY + 'px,' + stepY + 'px)');
                return;
            }
        }
        move();
        window.addEventListener("scroll", move);
        window.addEventListener("resize", update);
        AOS.refresh();
    }
    */

    //

    function scrollMagicz() {
        if (!document.querySelector('[data-action="broken-scroll"]')) return;
        const screenW = 993;
        let controller = null;
        let scene = null;
        let script = document.createElement('script');
        script.defer = true;
        script.src = "https://cdnjs.cloudflare.com/ajax/libs/gsap/2.1.3/TweenMax.min.js";
        document.body.append(script);
        script.onload = function() {
            let script_2 = document.createElement('script');
            script_2.defer = true;
            script_2.src = "https://cdnjs.cloudflare.com/ajax/libs/ScrollMagic/2.0.7/ScrollMagic.min.js";
            document.body.append(script_2);
            script_2.onload = function() {
                let script_3 = document.createElement('script');
                script_3.defer = true;
                script_3.src = "https://cdnjs.cloudflare.com/ajax/libs/ScrollMagic/2.0.7/plugins/animation.gsap.min.js";
                document.body.append(script_3);
                script_3.onload = function() {
                    update();
                    window.addEventListener('resize', update);

                }
            }
        }

        function move() {
            let scrollBlock = document.querySelector('[data-scroll-elem="true"]');
            let elemScrollW = scrollBlock.scrollWidth;
            let elemWidth = scrollBlock.offsetWidth;
            let rightWidth = elemScrollW - elemWidth;
            let scrollBlockH = scrollBlock.offsetHeight
            controller = new ScrollMagic.Controller();
            scene = new ScrollMagic.Scene({ triggerElement: "[data-action='broken-scroll']", duration: 1000, offset: scrollBlockH / 1.2 })
                .addTo(controller)
                .setTween(TweenMax.to("[data-scroll-elem='true']", 1, { right: rightWidth }))
                .setPin("[data-action='broken-scroll']");
            AOS.refresh();
        }

        function update() {
            if (document.documentElement.offsetWidth >= screenW) {
                if (controller) {
                    controller.destroy(true);
                    controller = null;
                }
                move();
            } else {
                if (controller) {
                    controller.destroy(true);
                    controller = null;
                }
            }
            AOS.refresh();
        }


    }

    //

    function tabsBlock({ parentClass, attr, cardParentEl }) {
        if (!document.querySelector(parentClass)) return false;
        let parent = document.querySelector(parentClass);
        let tabs = parent.querySelectorAll("button.tab");
        let cards = parent.querySelectorAll("div.card");
        let cardParent = parent.querySelector(cardParentEl);

        let swiperTab = null;
        let swipeTabOption = {
            slidesPerView: "auto",
            grabCursor: true,
            watchOverflow: true,
            centeredSlides: false,
            free: false,
            speed: 500,
            observeParents: true,
            observer: true,
            spaceBetween: 10,
        };
        let swiperCard = null;
        let swipeCardOption = {
            slidesPerView: "auto",
            grabCursor: true,
            watchOverflow: true,
            centeredSlides: false,
            free: false,
            speed: 500,
            observeParents: true,
            observer: true,
            spaceBetween: 10,
            pagination: {
                el: ".swiper-pagination",
            },
        };
        const sliderWidth_init = 600;

        function initActive(idx = false) {
            let activeBTN = null;
            let value = idx;
            if (!idx) {
                activeBTN = Array.from(tabs).find((item) =>
                    item.hasAttribute("data-active", true)
                );
                value = activeBTN.dataset[attr];
            }
            let cardLength = Array.from(cards).filter(
                (card) => card.dataset[attr] == value
            ).length;

            cards.forEach((card, i) => {
                if (card.dataset[attr] == value) {
                    if (cardLength == 1) {
                        card.classList.add("big");
                    }
                    cardParent.removeAttribute("style");
                    card.setAttribute("data-active", true);

                    setTimeout(() => {
                        card.classList.add("show");
                    });
                } else {
                    card.classList.remove("show");
                    card.removeAttribute("data-active");
                    card.classList.remove("big");
                }
                if (i == cards.length - 1 && swiperCard) {
                    swiperCard.update();
                    swiperCard.slideTo(0);
                }
                if (i == cards.length - 1) {
                    setTimeout(() => {
                        AOS.refresh();
                    });
                }
            });
        }
        initActive();

        function cleanActiveState() {
            tabs.forEach((tab) => {
                tab.removeAttribute("data-active");
            });
        }

        tabs.forEach((tab, i) => {
            tab.addEventListener("click", (e) => {
                cleanActiveState();
                tab.setAttribute("data-active", true);
                let idx = tab.dataset[attr];
                initActive(idx);
                if (swiperTab) {
                    swiperTab.slideTo(i);
                }
            });
        });

        document.addEventListener("click", (e) => {
            let targ = e.target.closest(".swiper-pagination-bullet");
            if (!targ || !swiperCard) return false;
            let children = Array.from(targ.parentElement.children);
            let idx = children.findIndex((item) => item == targ);
            swiperCard.slideTo(idx);
        });

        function initSliders() {
            if (swiperTab == null) {
                swiperTab = new Swiper(`${parentClass} .tabs.swiper`, swipeTabOption);
                let idx =
                    Array.from(tabs).findIndex((item) =>
                        item.hasAttribute("data-active")
                    ) || 0;
                swiperTab.slideTo(idx);
            }
            if (swiperCard == null) {
                swiperCard = new Swiper(
                    `${parentClass} .cards.swiper`,
                    swipeCardOption
                );
            }
        }

        function destroySliders() {
            if (swiperTab) {
                swiperTab.destroy(true, true);
                swiperTab = null;
            }
            if (swiperCard) {
                swiperCard.destroy(true, true);
                swiperCard = null;
            }
        }

        if (document.documentElement.offsetWidth <= sliderWidth_init) {
            initSliders();
        }

        window.addEventListener("resize", () => {
            if (document.documentElement.offsetWidth <= sliderWidth_init) {
                initSliders();
            } else {
                destroySliders();
            }
        });
    }

    function formControl({ parentClass }) {
        if (!document.querySelector(parentClass)) return false;
        let parent = document.querySelector(parentClass);
        let inputs = parent.querySelectorAll("input");
        let dropdowns = parent.querySelectorAll(".dropdown");

        inputs.forEach((input) => {
            input.addEventListener("focus", (e) => {
                let label = e.target.previousElementSibling;
                let parent = e.target.parentElement;
                label.classList.remove("hide");
                parent.classList.add("focus");
                parent.classList.remove("error");
                e.target.classList.add("holder_hide");
            });

            input.addEventListener("blur", (e) => {
                let value = e.target.value;
                let label = e.target.previousElementSibling;
                let parent = e.target.parentElement;
                if (!value) {
                    label.classList.add("hide");
                    e.target.classList.remove("holder_hide");
                }
                parent.classList.remove("focus");
            });
        });

        dropdowns.forEach((dropdown) => {
            let selects = dropdown.querySelectorAll("li[data-select]");

            dropdown.addEventListener("click", (e) => {
                let group = dropdown.parentElement;
                let list = dropdown.querySelector(".list");
                let svg = dropdown.querySelector(".trigger svg");
                if (list.classList.contains("show")) {
                    list.classList.remove("show");
                    svg.classList.remove("rotate");
                    group.classList.remove("focus");
                } else {
                    list.classList.add("show");
                    svg.classList.add("rotate");
                    group.classList.add("focus");
                }
            });

            selects.forEach((select) => {
                select.addEventListener("click", (e) => {
                    let value = select.dataset.select;
                    let parent = select.closest(".dropdown");
                    let input = parent.previousElementSibling;
                    let label = input.previousElementSibling;
                    input.value = value;
                    label.classList.remove("hide");
                });
            });
        });
        document.addEventListener("click", (e) => {
            let targ = e.target.closest(".dropdown");
            if (!targ) {
                dropdowns.forEach((dropdown) => {
                    let list = dropdown.querySelector("ul.list");
                    let svg = dropdown.querySelector(".trigger svg");
                    let group = dropdown.parentElement;
                    list.classList.remove("show");
                    svg.classList.remove("rotate");
                    group.classList.remove("focus");
                });
                return;
            }
            return;
        });
    }

    function columsSorted({ parentClass, elemsFrom, elemsTo, w }) {
        if (!document.querySelector(parentClass) || !elemsFrom || !elemsTo)
            return false;
        let parent = document.querySelector(parentClass);
        let elFrom = parent.querySelector(elemsFrom);
        let elements = Array.from(elFrom.children);
        let elTo = parent.querySelector(elemsTo);
        let replaced = false;
        let sortedMobState = false;
        let sortedDescState = false;

        function sortedDesc() {
            if (sortedDescState) return false;
            elements.forEach((element, i) => {
                i = i + 1;
                if (!replaced) {
                    let count = element.querySelector(".count");
                    count.textContent = i < 9 ? `0${i}.` : `${i}.`;
                }

                if (i % 2 == 0) {
                    elTo.append(element);
                }
            });
            if (!replaced) {
                replaced = true;
            }
            sortedDescState = true;
            sortedMobState = false;
            setTimeout(() => {
                AOS.refresh();
            });
        }

        function sortedMob() {
            if (sortedMobState) return false;
            elements.forEach((element, i) => {
                i = i + 1;
                if (!replaced) {
                    let count = element.querySelector(".count");
                    count.textContent = i < 9 ? `0${i}.` : `${i}.`;
                }
                elFrom.append(element);
            });
            if (!replaced) {
                replaced = true;
            }
            sortedMobState = true;
            sortedDescState = false;
            setTimeout(() => {
                AOS.refresh();
            });
        }

        if (document.documentElement.offsetWidth >= w) {
            sortedDesc();
        } else {
            sortedMob();
        }

        window.addEventListener("resize", () => {
            if (document.documentElement.offsetWidth >= w) {
                sortedDesc();
            } else {
                sortedMob();
            }
        });
    }

    function setMap(id) {
        if (!document.querySelector(`#${id}`)) return false;
        let parent = document.querySelector(`#${id}`);
        let body = document.body;
        let iconUrl = parent.dataset.marker;
        let cooX = parent.dataset.x;
        let cooY = parent.dataset.y;
        let zoom = parent.dataset.zoom;
        let zoom_max = parent.dataset.maxzoom;
        let tooltipText = parent.dataset.tooltip;

        // let script = document.createElement('script');
        // script.src="/js/libs/map.js";
        // // script.integrity = "sha512-XQoYMqMTK8LvdxXYG3nZ448hOEQiglfqkJs1NOQV44cWnUrBc8PkAOcXy20w0vlaXaVUearIOBhiXZ5V3ynxwA==";
        // script.crossorigin="true";
        // body.append(script);
        // script.onload=function(){
        //   console.log('load map')
        // }

        let myIcon = L.icon({
            iconUrl: iconUrl,
            iconSize: [20, 30],
        });
        let map = L.map(id).setView([cooX, cooY], zoom);
        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
            maxZoom: zoom_max,
        }).addTo(map);
        L.marker([cooX, cooY], { icon: myIcon })
            .addTo(map)
            .bindTooltip(tooltipText, { direction: "bottom", offset: [0, 15] })
            .openTooltip();
    }

    document.addEventListener("DOMContentLoaded", () => {
        headerControll();
        //brokenScroll();
        scrollMagicz();
        tabsBlock({
            parentClass: ".hunter_teams",
            attr: "region",
            cardParentEl: ".cards",
        });
        formControl({ parentClass: ".form_field form.form" });
        columsSorted({
            parentClass: ".prevention_diabetes",
            elemsFrom: ".column._1",
            elemsTo: ".column._2",
            w: "993",
        });
        setMap("map");
    });
} catch (e) {
    console.log(e);
}